import { Badge, Body, CustomLink, styled } from '@teko/ds-desktop';
import { NewBellOutlined, NotificationsOutlined } from '@teko/ds-icon';
import { getTrackingData } from '@teko/tracking';
import { Dropdown, DropdownMenu, DropdownToggle } from '@teko/ui';
import {
  NavigationButton,
  NavigationIconButton,
} from 'components/desktop/organisms/style';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { useNotification } from '../NotificationProvider';

const MiniNotification = dynamic(() =>
  import('./MiniNotification').then((mod) => mod.MiniNotification),
);
interface NotificationOverviewProps {
  title?: boolean;
}
const StyledDropdown = styled(Dropdown)`
  width: auto;
`;
const WrapperBadge = styled.div`
  position: absolute;
  top: 10px;
  left: calc(50% + 12px);
`;

const NewLayoutWrapperBadge = styled.div`
  position: absolute;
  top: 2px;
  left: calc(50% + 10px);
`;

export const NotificationOverview: React.FC<NotificationOverviewProps> = ({
  title = false,
}: NotificationOverviewProps) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const { unRead } = useNotification();
  const { displayNewLayout } = useTenantConfig();
  return (
    <StyledDropdown
      isOpen={openDropdown}
      toggle={() => {
        setOpenDropdown((prev) => !prev);
      }}
      toggleType="hover"
      onHide={(): void => setOpenDropdown(false)}
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'notificationItem',
        target: 'notification',
      })}
    >
      <DropdownToggle>
        {displayNewLayout ? (
          <CustomLink href="/notification">
            <NavigationIconButton className="button">
              <NewBellOutlined size={20} />
              {!!unRead && unRead > 0 && (
                <NewLayoutWrapperBadge>
                  <Badge count={unRead} />
                </NewLayoutWrapperBadge>
              )}
            </NavigationIconButton>
          </CustomLink>
        ) : (
          <NavigationButton
            className="button"
            style={{ flexDirection: 'column', minWidth: '68px' }}
          >
            <NotificationsOutlined
              className="noti"
              size={36}
              color="textSecondary"
            />
            {!!unRead && unRead > 0 && (
              <WrapperBadge>
                <Badge count={unRead} />
              </WrapperBadge>
            )}
            {title && (
              <Body
                level={2}
                weight="medium"
                color="textSecondary"
                className="title"
              >
                {t('Thông báo')}
              </Body>
            )}
          </NavigationButton>
        )}
      </DropdownToggle>
      <DropdownMenu popperConfig={{ placement: 'bottom-end' }}>
        <MiniNotification onHide={(): void => setOpenDropdown(false)} />
      </DropdownMenu>
    </StyledDropdown>
  );
};
